import styled from 'styled-components';
import VectorRight from '@catalogo/ui-americanas-mobile-qna/src/svgs/vector-right.svg';
import TriangleAlert from '@catalogo/ui-americanas-mobile-qna/src/svgs/alert-triangle.svg';

interface ContentProps {
  hasTitle: boolean;
}

interface SvgProps {
  hastitle?: boolean;
}

const CheckIcon = styled(VectorRight)<SvgProps>`
  margin-right: 10px;
`;

const TagAlready = styled.div`
  background: #d9ffd9;
  border-radius: 4px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 120%;
  color: #404040;
  padding: 8px;
  margin: 14px 0 8px 0;
  display: flex;
  align-items: center;
  text-transform: none;
`;

const AlertIcon = styled(TriangleAlert)<SvgProps>`
  width: 14px;
  height: 14px;
  margin-top: 2px;
  fill: ${({ hastitle }) => (hastitle ? '#282828' : '#C60028')};
  margin-right: 10px;
`;

const Box = styled.div<ContentProps>`
  display: flex;
  align-items: normal;
  padding: 8px;
  margin-top: 14px;
  border-radius: 8px;
  background-color: ${({ hasTitle }) => (hasTitle ? '#FFD4C5' : '')};
`;

const Content = styled.div<ContentProps>`
  text-transform: none;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 140%;
  color: ${({ hasTitle }) => (hasTitle ? '#575757' : '#c60028')};
`;

const Strong = styled.span`
  font-weight: bold;
  display: block;
  color: #404040;
`;

export { Box, Content, Strong, CheckIcon, AlertIcon, TagAlready };
